import Button      from 'components/ui/buttons/button';
import loadOnClick from 'components/ui/buttons/helpers/load_on_click';

const LoadOnClickButton = loadOnClick()(Button);
export default LoadOnClickButton;
